import { render, staticRenderFns } from "./189.vue?vue&type=template&id=1bd41846&scoped=true&"
var script = {}
import style0 from "./189.vue?vue&type=style&index=0&id=1bd41846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd41846",
  null
  
)

export default component.exports